// src/api/apiConfig.js

// 🌐 Base API URL (Change when deploying)
export const BASE_URL = process.env.REACT_APP_API_BASE_URL || 'https://tixoza.com/api';
export const IMAGE_BASE_URL = process.env.REACT_APP_IMAGE_BASE_URL || 'https://tixoza.com';
// export const BASE_URL = process.env.API_BASE_URL;

// Helper to process image URLs from API (removes :8000 port for production)
export const processImageUrl = (url) => {
  if (!url) return url;
  return url.replace('https://tixoza.com', IMAGE_BASE_URL);
};
// Helper: get stored tokens
export const getTokens = () => {
  const access = localStorage.getItem("access");
  const refresh = localStorage.getItem("refresh");
  return { access, refresh };
};

// 🔁 Refresh token logic
export const refreshAccessToken = async () => {
  const { refresh } = getTokens();
  if (!refresh) {
    // No refresh token - logout
    handleTokenExpiration();
    throw new Error("No refresh token found");
  }

  const res = await fetch(`${BASE_URL}/accounts/token/refresh/`, {
    method: "POST",
    headers: { "Content-Type": "application/json" },
    body: JSON.stringify({ "refresh": refresh }),
  });

  if (!res.ok) {
    // Refresh failed - logout
    handleTokenExpiration();
    throw new Error("Token refresh failed");
  }

  const data = await res.json();
  localStorage.setItem("access", data.access);
  if (data.refresh) localStorage.setItem("refresh", data.refresh);
  console.log('token refreshed')
  return data.access;
};

// Handle token expiration - clear tokens and redirect to login
const handleTokenExpiration = () => {
  // localStorage.removeItem("access");
  // localStorage.removeItem("refresh");
  // localStorage.removeItem("user");
  // // Redirect to login page
  // window.location.href = "/signup";
};

// 🔐 Authenticated Fetch Wrapper
export const authFetch = async (endpoint, options = {}) => {
  let { access } = getTokens();
  let response = await fetch(`${BASE_URL}${endpoint}`, {
    ...options,
    headers: {
      ...(options.body instanceof FormData ? {} : { "Content-Type": "application/json" }),
      Authorization: access ? `Bearer ${access}` : "",
      ...(options.headers || {}),
    },
  });

  // If token expired → try refresh once
  if (response.status === 401) {
    try {
      const newAccess = await refreshAccessToken();
      response = await fetch(`${BASE_URL}${endpoint}`, {
        ...options,
        headers: {
          ...(options.body instanceof FormData ? {} : { "Content-Type": "application/json" }),
          Authorization: `Bearer ${newAccess}`,
          ...(options.headers || {}),
        },
      });
    } catch (err) {
      console.error("Session expired. Please login again.");
      throw err;
    }
  }

  if (!response.ok) {
    let errorData;
    try {
      errorData = await response.json();
    } catch (e) {
      throw new Error("API error");
    }

    // Extract the most descriptive error message
    // 1. Check for 'items' (as requested by user)
    // 2. Check for 'detail'
    // 3. Check for specific field errors (e.g., { "email": ["..."] })
    // 4. Default to "API error"
    let errorMessage = "API error";

    if (errorData.items) {
      errorMessage = errorData.items;
    } else if (errorData.detail) {
      errorMessage = errorData.detail;
    } else if (typeof errorData === "object") {
      // Handle Django-style field errors: { "field": ["error"] }
      const firstEntry = Object.values(errorData)[0];
      if (Array.isArray(firstEntry) && firstEntry.length > 0) {
        errorMessage = firstEntry[0];
      } else if (typeof firstEntry === "string") {
        errorMessage = firstEntry;
      }
    }

    throw new Error(errorMessage);
  }

  // For 204 No Content, return null
  if (response.status === 204) {
    return null;
  }

  return response.json();
};
